/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MeasurementUnit = "CM" | "IN" | "%future added value";
export type PdpRespHeroCarousel_user = {
    readonly profile: {
        readonly measurementUnit: MeasurementUnit | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarouselRequestMoreImages_user" | "PdpRespIconBubblesWrapper_user">;
    readonly " $refType": "PdpRespHeroCarousel_user";
};
export type PdpRespHeroCarousel_user$data = PdpRespHeroCarousel_user;
export type PdpRespHeroCarousel_user$key = {
    readonly " $data"?: PdpRespHeroCarousel_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespHeroCarousel_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespHeroCarousel_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "measurementUnit",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselRequestMoreImages_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespIconBubblesWrapper_user",
      "args": null
    }
  ]
};
(node as any).hash = '0bbf9ca951bfaadf5ee91afff6c49603';
export default node;
